import BaseBox from '@material-ui/core/Box'

const Box = BaseBox

export default Box
